
export function pmdbService(http) {
    const serviceName = "Pmdb";

    return {
        getDropDownListActivites:(projectId,roleMembers)=>{
            const data={
                projectId,
                roleMembers
            }
            return http.post(serviceName+"/GetDropDownListActivites",data);
        },
        //getGridData:(roleMembers,pageNumber,pageSize,sortBy,projectId,unSetChecked,filters)=>{
        getGridData:(roleMembers,projectId,isSetChecked)=>{

              const data = {
                    roleMembers,
                    projectId,
                    isSetChecked
                };

            return http.post(serviceName + "/GetGridData",data);

            // const newSortBy=(sortBy||[]).map(item=>( {member:item.id,sortDirection:item.desc?"Descending":"Ascending"}))

            // const newfilter= Object.keys(filters).map(key => {
            //     return {
            //         member:key,
            //         operator:filters[key].operator,
            //         value: filters[key].columnType=="number"?Number(filters[key].value):filters[key].value
            //     };
            //   });

            //   filters= {
            //         logic:"And",
            //         filters:[
            //             ...newfilter,
            //             {
            //                 member:"projectId",
            //                 operator:"EqualTo",
            //                 value:projectId
            //             },
            //             {
            //                 member:"standardActivityId",
            //                 operator:unSetChecked?"EqualTo":"IsGreaterThanOrEqualTo",
            //                 value:0
            //             }
            //         ]
            //     };

            //   const data = {
            //     roleMembers,
            //     projectId,
            //     dataAttribute:{
            //         page:pageNumber,
            //         pageSize,
            //         sorts:newSortBy.lenght==0?[{member:"StartDate",sortDirection:"Ascending"}]:newSortBy,
            //         filter:filters
            //     }
            // };

            // return http.post(serviceName + "/GetGridData",data);
        },
        updateActivity:(activityId, standardActivityId)=>{
            const data={
                activityId,
                standardActivityId
            }
            return http.post(serviceName + "/UpdateActivity",data);
        },
        getActivities: (projects, activityDescription) =>{

            const _projects=projects.map(a=>`projectIds=${a}`).join('&');

            return http.get(serviceName+`/GetActivities?${_projects}&activityDescription=${activityDescription}`);
        }
       

    }
}